module.exports = __webpack_public_path__ + "static/media/best-buy-large.94168674.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/best-buy-large.png
// module id = 739
// module chunks = 27